module.exports = __webpack_public_path__ + "static/media/Screen Shot 2023-02-20 at 14.16.14.3c9b62cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Screen Shot 2023-02-20 at 14.16.14.png
// module id = 1243
// module chunks = 1